export default __webpack_public_path__ + "static/char-v-43-ja-162677670515222eac3cd5cfc74e2bc3.mp4";